import { usersAdapter, UserState } from "./user.entity";
import { createReducer, on, Action } from "@ngrx/store";
import { usersActionTypes } from "./user.actions";
import { authActionTypes } from "../../../auth/store/auth.actions";

export const initialState: UserState = usersAdapter.getInitialState({
    ids: [],
    total: 0,
    loaded: false,

    paginationMetaData: null,
    searchString: null,
    error: null
});

export const usersReducerObj = createReducer(
    initialState,

    on(usersActionTypes.setUsersAction, (state, action) => {
        console.log("setUsersAction data ", action);

        if ( action.users && action.users.Users !== null && action.users.Users.length > 0 ) {
            return usersAdapter.addAll(action.users.Users, {
                ...state,
                paginationMetaData: action.users.PaginationMetaData,
                searchString: action.searchString,
                loaded: true,
                total: action.users.PaginationMetaData.TotalCount,
            });
        } else {
            return usersAdapter.removeAll(state);

            /* return {
                ...state,
                paginationMetaData: null,
                //searchString: null,
                loaded: true,
                total: 0
            }; */
        }
    }),

    on(usersActionTypes.setUsersActionFail, (state, action) => {
            console.log('setUsersActionFail ',action);
            return {
            ...state,
            error: action.error
        }
    }),

    on(usersActionTypes.clearUserSearchStringAction, (state, action) => ({
        ...state,
        searchString: ''
    })),

    on(usersActionTypes.clearUsersAction, (state, action) => {
        return usersAdapter.removeAll(state);
    }),

    on(authActionTypes.LogOut, (state, action) => {
        return usersAdapter.removeAll({
            ...state,
            loaded: false,
            total: 0,
        });
    }),
);

export function reducer(
    state: UserState = initialState,
    action: Action
): UserState {
    return usersReducerObj(state, action);
}

export const usersSelectors = usersAdapter.getSelectors();
